import { p as proxyCustomElement, H, h, c as Host } from './p-DTTCzifR.js';

const Button = /*@__PURE__*/ proxyCustomElement(class Button extends H {
    constructor() {
        super();
        this.__registerHost();
    }
    /**
     * The first name
     */
    label;
    render() {
        return (h(Host, { key: '6d8cd1675cb92185f11a363897c0157ffe14f773' }, h("slot", { key: '0d9bdc2f9307d8545762019da83ec51f8e5f401e', name: 'icon' }), h("slot", { key: 'a71a60c1d70f5e6c83bbc1a3f2c9aeb2b55313a0' }, this.label)));
    }
}, [4, "wangs-button", {
        "label": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wangs-button"];
    components.forEach(tagName => { switch (tagName) {
        case "wangs-button":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, Button);
            }
            break;
    } });
}

const WangsButton = Button;
const defineCustomElement = defineCustomElement$1;

export { WangsButton, defineCustomElement };
